module.exports = __webpack_public_path__ + "static/media/hashtag-user.5613b2da.jpg";